import type { HelpFile } from '../../types/help'
import { NotificationTemplatesTestIds } from '../../../testids/NotificationTemplatesTestIds'

export const notificationTemplatesHelp: HelpFile = {
  docPage: '/docs/admin/notification-templates',
  texts: {
    [NotificationTemplatesTestIds.notificationTemplatesList]:
      'Notification email templates. Each event type ships a classpath default; editing a template stores a database override that can be reverted at any time.',
    [NotificationTemplatesTestIds.notificationTemplatesTable]: null,
    [NotificationTemplatesTestIds.badgeCustomised]:
      'A "Customised" badge means a database override row backs this template; "Default" means the shipped classpath text is in use.',
    [NotificationTemplatesTestIds.badgeDefault]: null,
    [NotificationTemplatesTestIds.colKey]:
      'The template key — the event type (e.g. "access-request-submitted") this template renders for.',
    [NotificationTemplatesTestIds.colSubject]:
      'The effective email subject line for this template.',
    [NotificationTemplatesTestIds.colState]:
      'Whether the template uses the shipped default or a customised database override.',
    [NotificationTemplatesTestIds.colActive]:
      'Whether the template is active and will be used for sending.',
    [NotificationTemplatesTestIds.colLastModified]:
      'When the customised override was last saved (empty for default templates).',
  },
}
